import React, { useState, useEffect, useContext } from "react";

//import css
import "./RecentPaymentsCards.scss";

//import icons
import { FaPercentage } from "react-icons/fa";
import { MdCreditScore } from "react-icons/md";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { fetchTenantPayments } from "../../../../redux/slices/sliceActions";

//import context
import { MyContext } from "../../../../tenantsDashContext";

const RecentPaymentsCards = () => {
  const { sharedValue, setSharedValue } = useContext(MyContext);

  // Manually created sample data for payments
  const samplePayments = [
    {
      payment_id: "P12345",
      amount: 500,
      payment_narration: "Rent Payment for August",
      created_at: "2023-08-05T10:45:00",
      rent_amount: 400,
      arrears_amount: 100,
      garbage_charge_amount: 50,
      water_bill_amount: 30,
      service_fee_amount: 20,
      invoice: {
        invoice_id: "INV001",
        payment_status: 1, // Complete payment
      },
    },
    {
      payment_id: "P67890",
      amount: 250,
      payment_narration: "Partial Rent for September",
      created_at: "2023-09-10T12:00:00",
      rent_amount: 500,
      arrears_amount: 50,
      garbage_charge_amount: 20,
      water_bill_amount: 40,
      service_fee_amount: 15,
      invoice: {
        invoice_id: "INV002",
        payment_status: 0, // Partial payment
      },
    },
    {
      payment_id: "P24680",
      amount: 700,
      payment_narration: "Rent Payment for October",
      created_at: "2023-10-01T09:30:00",
      rent_amount: 600,
      arrears_amount: 0,
      garbage_charge_amount: 40,
      water_bill_amount: 30,
      service_fee_amount: 30,
      invoice: {
        invoice_id: "INV003",
        payment_status: 1, // Complete payment
      },
    },
  ];

  // Initialize state with sample data
  const [paymentsReceived, setPaymentsReceived] = useState(samplePayments);
  const [visiblePayments, setVisiblePayments] = useState(3);
  const [expandedCardIndex, setExpandedCardIndex] = useState(null);

  // Filter payments based on sharedValue (Invoices filter)
  const paymentData = {
    payments: paymentsReceived,
  };

  if (sharedValue === "Invoices") {
    paymentData.payments = paymentsReceived.filter(
      (payment) => payment.invoice.payment_status === 0
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getPaymentStatus = (status) => {
    return status === 0 ? "Partial" : "Complete";
  };

  const handleSeeMore = () => {
    setVisiblePayments((prevVisiblePayments) => prevVisiblePayments + 5);
  };

  const handleHideAll = () => {
    setVisiblePayments(5);
  };

  const toggleExpandCard = (index) => {
    setExpandedCardIndex(expandedCardIndex === index ? null : index);
  };
  return (
    <div className="payments-container">
      {paymentData.payments.slice(0, visiblePayments).map((payment, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className="card" onClick={() => toggleExpandCard(index)}>
            <div className="icon-and-description">
              <div className="icon">
                {getPaymentStatus(payment.invoice.payment_status) ===
                "Partial" ? (
                  <FaPercentage />
                ) : (
                  <MdCreditScore />
                )}
              </div>
              <div className="description-and-ammount">
                <div className="description">
                  {shortenString(payment.payment_narration)}
                </div>
                <div className="amount">{payment.amount}</div>
              </div>
            </div>
            <div className="date">{formatDate(payment.created_at)}</div>
          </div>

          {expandedCardIndex === index && (
            <div className="extra-info">
              <div className="extra-info-title">Transaction Details</div>
              <div className="details-and-title">
                <div className="tile">Invoice ID:</div>
                <div className="details"> {payment.invoice.invoice_id}</div>
              </div>
              <div className="details-and-title">
                <div className="tile">Rent Amount:</div>
                <div className="details"> {payment.rent_amount}</div>
              </div>
              <div className="details-and-title">
                <div className="tile"> Arrears Amount:</div>
                <div className="details"> {payment.arrears_amount}</div>
              </div>
              <div className="details-and-title">
                <div className="tile">Garbage Charge: </div>
                <div className="details">{payment.garbage_charge_amount}</div>
              </div>
              <div className="details-and-title">
                <div className="tile">Water Bill Amount:</div>
                <div className="details"> {payment.water_bill_amount}</div>
              </div>
              <div className="details-and-title">
                <div className="tile">Service Fee Amount:</div>
                <div className="details"> {payment.service_fee_amount}</div>
              </div>

              <div className="details-and-title">
                <div className="tile">Payment ID:</div>
                <div className="details"> {payment.payment_id}</div>
              </div>
              <div style={{
                backgroundColor: "#0B2C3C",
                color: "white",
                padding: "7px 10px",
                borderRadius: "5px",
                cursor: "pointer",
                marginTop: "10px",
                fontSize: "14px",
              }}> Approve Payment</div>
            </div>
          )}
        </div>
      ))}

      {visiblePayments < paymentData.payments.length && (
        <div className="see-more-buttons-container">
          <button className="see-more-button" onClick={handleSeeMore}>
            See More
          </button>
        </div>
      )}

      {visiblePayments > 5 && (
        <div className="see-more-buttons-container">
          <button className="hide-all-button" onClick={handleHideAll}>
            Hide All
          </button>
        </div>
      )}
    </div>
  );
};

function shortenString(str) {
  if (str.length > 14) {
    return str.slice(0, 14) + "...";
  }
  return str;
}

export default RecentPaymentsCards;
